module.exports = __webpack_public_path__ + "static/img/48849378_l.0d66b10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/48849378_l.png
// module id = t5Vx
// module chunks = 6